import { defineMessages } from 'react-intl';

export const messages: {
	closeButton: {
		defaultMessage: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		id: string;
	};
	timeoutIconAlt: {
		defaultMessage: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'twc.xflow.modal.timeout.heading',
		defaultMessage: 'Activation is taking longer than expected',
		description:
			'Heading displayed on the timeout screen of the trial activation modal when activation is slow',
	},
	description: {
		id: 'twc.xflow.modal.timeout.description',
		defaultMessage:
			"Don't worry - we're still working on it. You'll receive an email when your products are ready to use.",
		description:
			'Body text on the timeout screen reassuring the user that activation is in progress and an email will follow',
	},
	closeButton: {
		id: 'twc.xflow.modal.timeout.close.button',
		defaultMessage: 'Close',
		description: 'Button label to close the timeout screen in the trial activation modal',
	},
	timeoutIconAlt: {
		id: 'twc.xflow.modal.timeout.icon.alt',
		defaultMessage: 'Timeout icon',
		description: 'Alt text for the timeout icon shown on the trial activation timeout screen',
	},
});
